<!-- Notifications -->
<div class="payment-notifications__wrapper">
    <!-- note: uncomment when implemented with actual logic
	<app-notification [style]="'information'" [icon]="'icons.svg#general--information'"
		[title]="'bookingPayment.title.fopCannotPurchaseInsuranace' | ibeadmin | async" *ngIf="hasPaymentMethodRestrictions">
		<div message>
			<span>
				{{'bookingPayment.text.chooseToPayATM' | ibeadmin | async}} 
				<a (click)="INDRA_handleRemoveInsurance()" 
					class="link"
					href="javascript:;" 
					role="button">
					{{'bookingPayment.text.removeTravelInsurance' | ibeadmin | async}} 
				</a>
				, {{'bookingPayment.text.inCaseYouPrefer' | ibeadmin | async}} 
			</span>
		</div>
	</app-notification>

	<app-notification [style]="'success'" [icon]="'icons.svg#check-in--check-in'"
		[title]="'bookingPayment.title.insuranceRemoved' | ibeadmin | async" *ngIf="removedPaymentMethodRestrictions">
		<div message>
			<span>
				{{'bookingPayment.text.doYouWanTo' | ibeadmin | async}} 
				<a (click)="INDRA_insuranceAdd()" class="link" href="javascript:;" role="button">
					{{'bookingPayment.text.reinstateInsurance' | ibeadmin | async}} 
				</a>?
			</span>
		</div>
	</app-notification>
	-->

    <app-notification [style]="'error'" [icon]="'icons.svg#general--information'" [title]="'bookingPayment.title.issueWithCCPayment' | ibeadmin | async" *ngIf="hasPaymentError">
        <div message>
            <span>{{'bookingPayment.text.youCanTryAgain' | ibeadmin | async}} </span>
        </div>
    </app-notification>

    <app-notification [style]="'note'" [icon]="'icons.svg#services--book_hotel'" [title]="'bookingPayment.text.ccDetailsForHotel' | ibeadmin | async" *ngIf="hasPartnerHotelExtra">
        <div message>
            <span>{{'bookingPayment.text.ccDontHaveToPay' | ibeadmin | async}}</span>
        </div>
    </app-notification>

    <!--
	<app-notification [style]="'alert'" [icon]="'icons.svg#general--information'" *ngIf="!enabledPaymentMethods.length">
		<div message>
			<span>{{'bookingPayment.text.allPaymentMethodsDisabled' | ibeadmin | async}}</span>
		</div>
	</app-notification>
	-->
</div>


<!-- Payment method selection -- DESKTOP -->
<ul class="payment-methods__list hidden-mobile hidden-tablet-portrait" *ngIf="availablePaymentMethods.length > 1 && (!isScreenMobileTabletPortrait && !isIE)" [ngStyle]="INDRA_getGridStyle()">
    <li class="payment-methods__item-wrapper" *ngFor="let method of availablePaymentMethods">
        <button class="payment-methods__item {{ INDRA_getMethodStyles(method) }}" (click)="INDRA_selectPaymentMethod(method)" [tooltip]="disabledTooltipMessage && disabledPaymentMethods.includes(method) ? disabledTooltipMessage : null">
			<app-svg svg="sprite.svg#payment_method--{{ paymentMethods[method]?.image || 'dummy' }}" 
				class="payment-method-image"
				aria-hidden="true" 
				[alt]="paymentMethods[method]?.label + ' logo'">
			</app-svg>
			<span class="payment-method-label">
				{{ INDRA_paymentMethods(paymentMethods[method]?.label) || 'Unhandled FOP' }}
				<!--
				<span class="payment-method-label-details" *ngIf="paymentMethods[method]?.details">{{paymentMethods[method]?.details}}</span>
				-->
			</span>
		</button>
    </li>
</ul>

<!-- Payment method selection -- MOBILE -->
<div class="payment-methods__list--mobile" *ngIf="availablePaymentMethods.length > 1 && (isScreenMobileTabletPortrait || isIE)">
    <app-large-input-select [id]="'select-payment-method'" [inputOptions]="cardOptions" [label]="'bookingPayment.label.paymentMethod' | ibeadmin | async" [placeholderLabel]="'bookingPayment.text.selectPaymentMethod' | ibeadmin | async" [icon]="INDRA_printSelectedPaymentMethodIcon()"
        [inputValue]="selected_method" (change)="INDRA_selectPaymentMethod($event.target.value)">
    </app-large-input-select>
</div>

<!-- Credit Card -->
<app-payment-method-card *ngIf="selected_method === 'credit_card'" [type]="'credit'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-card>

<!-- Debit Card -->
<app-payment-method-card *ngIf="selected_method === 'debit_card'" [type]="'debit'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-card>

<!-- Bancontact -->
<app-payment-method-card *ngIf="selected_method === 'bancontact'" [type]="'bancontact'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-card>

<!-- Multibanco -->
<app-payment-method-multibank *ngIf="selected_method === 'multibanco'" [hasMilesPayable]="hasMilesPayable" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-multibank>

<!-- MB Way -->
<app-payment-method-mb-way *ngIf="selected_method === 'mb_way'" [hasMilesPayable]="hasMilesPayable" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-mb-way>

<!-- Paypal -->
<app-payment-method-paypal *ngIf="selected_method === 'paypal'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-paypal>

<!-- Alipay -->
<app-payment-method-alipay *ngIf="selected_method === 'alipay'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-alipay>

<!-- Klarna -->
<app-payment-method-klarna *ngIf="selected_method === 'klarna_pay_now'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-klarna>

<app-payment-method-klarna-pay-later *ngIf="selected_method === 'klarna_pay_later'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-klarna-pay-later>

<!-- POLi -->
<app-payment-method-poli *ngIf="selected_method === 'poli'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-poli>

<!-- iDEAL -->
<app-payment-method-ideal *ngIf="selected_method === 'ideal'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-ideal>

<!-- Bank Transfer -->
<app-payment-method-bank-transfer *ngIf="selected_method === 'bank_transfer'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-bank-transfer>

<!-- Bank Transfer - BR -->
<app-payment-method-bank-transfer-br *ngIf="selected_method === 'bank_transfer_br'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-bank-transfer-br>

<!-- Multicaixa -->
<app-payment-method-multicaixa *ngIf="selected_method === 'multicaixa'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-multicaixa>

<!-- Bancontact Mobile -->
<!--
<app-payment-method-bancontact *ngIf="selected_method === 'bancontact'"></app-payment-method-bancontact>
-->

<!-- Pickup -->
<app-payment-method-pickup *ngIf="selected_method === 'pickup'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-pickup>

<!-- Loterias -->
<app-payment-method-loterias *ngIf="selected_method === 'caixa_loterias'" [displayCovidTermsAndCondition]="displayCovidTermsAndCondition">
</app-payment-method-loterias>
